import { GENDER_MAP } from '../constants';
import getOption from './getOption';

var gender = function gender(_ref) {
  var label = _ref.label,
      values = _ref.values,
      urlParams = _ref.urlParams;
  var param = 'genderFilter';
  var options = values.map(function (gender) {
    return {
      ariaLabel: "Click to filter by ".concat(gender),
      value: gender,
      label: GENDER_MAP[gender.toLowerCase()]
    };
  });
  var option = urlParams.get(param) || '';
  return {
    expand: false,
    filter: function filter(_ref2, value) {
      var genderDisplay = _ref2.properties.genderDisplay;
      return genderDisplay === value || genderDisplay === 'Unisex' || genderDisplay === 'None';
    },
    label: label,
    param: param,
    options: options,
    selected: getOption(options, GENDER_MAP[option.toLowerCase()])
  };
};

export default gender;